<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="table-container" *ngIf="activityData">
    <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
        <div class="">
            <div class="search-container">
                <span class="fa fa-search form-control-feedback"></span>
                <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
                    [(ngModel)]="searchValue">
            </div>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
                <path style="fill:'#FFFFFF'"
                    d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
            </svg>
            <span class="reload_text text-white">Settings</span>
        </div>
        <div class="">
            <div class="action-buttons-container d-flex gap-2">
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openAddPopup()" (keydown.enter)="openAddPopup()" *ngIf="message.showEffectiveActionButtons"
                    matTooltip="Add Effectiveness Check">
                    <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
                    <span class="reload_text text-white">Add New</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
                    <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Excel Report</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReport('Pdf')" (keydown.enter)="openReport('Pdf')">
                    <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">PDF Report</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
                    (keydown.enter)="openAuditTrail('overAll',0)">
                    <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Audit Trail</span>
                </div>
                <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="refreshGridData()" (keydown.enter)="refreshGridData()" matTooltip="Refresh Grid">
                    <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
                    <span class="reload_text">Reload</span>
                </div>
            </div>
        </div>
    </div>

    <table class="dynamic-table-container">
        <th style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
                <div>
                    <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                </div>

            </div>
        </th>
        <th id="grid-header-container" (focus)="focusEmpty()"
            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;" [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width,'max-width': oneQmsUsersDataForTable1Data.width,'overflow': 'hidden',
      'text-overflow': 'ellipsis',
      'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssfunction(0)">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
                <div class="d-flex gap-2 align-items-center">
                    <div class="sort"
                        (click)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)"
                        (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)">
                        <div><i *ngIf="sortedDisplayColumn==oneQmsUsersDataForTable1Data.fieldColumnarray && sortDirection=='asc'"
                                class='fas fa-angle-up' style='font-size:11px'></i></div>
                        <div><i *ngIf="sortedDisplayColumn==oneQmsUsersDataForTable1Data.fieldColumnarray && sortDirection=='desc'"
                                class='fas fa-angle-down' style='font-size:11px'></i></div>
                        <img *ngIf="sortedDisplayColumn!=oneQmsUsersDataForTable1Data.fieldColumnarray"
                            src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                    </div>
                </div>
            </div>
        </th>
        <th id="menu" class="sticky-col first-col"></th>
        <!-- search input row is added -->
        <tr>
            <td [class]="
                makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''
              "></td>
            <td *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
                [ngStyle]="{'min-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200,'max-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200}"
                class="sticky-dynamic-col1">
                <div class="row-search-container">
                    <input type="text" class="form-control" placeholder="Search"
                        (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
                </div>
            </td>
        </tr>
        <!-- data row -->
        <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
            [class.highlightRow]="list.childCheckBoxs == true">
            <td style="min-width: 60px; text-align: center;"
                [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                <div style="display: flex;">
                    <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                        <i class="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                    <div>
                        <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                            (change)="dataGridChildCheckBoxChecked($event, list, idx)">
                    </div>
                </div>
            </td>

            <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
                class="sticky-dynamic-row1" (click)="openEcDetailsPopup(list, i)" (focus)="focusEmpty()"
                (keydown.enter)="openEcDetailsPopup(list, i)" (mouseover)="cssfunction(i)">
                <span *ngIf="key.dataType=='CHECKBOX'">
                    <div class="gridCheckBoxes">
                        <img *ngIf="list[key.columnsListarray]" src="../../../assets/img/cr_module/accessSymbol.svg"
                            width="16" height="16" alt="access" />
                        <img *ngIf="list[key.columnsListarray] == false"
                            src="../../../assets/img/cr_module/noAcessSymbol.svg" width="16" height="16"
                            alt="no access" />
                    </div>
                </span>


                <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
                    <div class="download-button-continer btn-align" mat-dialog-actions>
                        <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                            (click)="getClobData(list,key.columnsListarray)">
                            <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px"
                                alt="download">
                            <span class="ms-1">View</span>
                        </button>
                    </div>
                </span>

                <span
                    *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">{{
                    list[key.columnsListarray] }}</span>
                <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
            </td>
            <td class="sticky-col first-col">
                <div class="action-icons">
                    <i class="fa-solid fa-clipboard" title="Audit Trail" style="margin-left: 5px;"
                        *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('individual',list)"
                        (keydown.enter)="openAuditTrail('individual',list)"></i>
                </div>
            </td>
        </tr>
    </table>
    <div class="d-flex justify-content-center">
        <div class="width-cheat small paginationCell">
            <div class="d-flex align-items-center gap-3">
                <div class="pagination_text mt-3">
                    {{ showingRowsText }}
                    1-{{ perPage }} of {{ collectionSize | number }}
                </div>
                <div>
                    <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)"
                        [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                        [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                        [boundaryLinks]="true" size="sm">
                    </ngb-pagination>
                </div>
                <div ngbDropdown class="mt-3">
                    <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                        ngbDropdownToggle>
                        {{ perPage }}
                        <i class="ms-1 fa-solid fa-chevron-down"></i>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                        <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                        <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                        <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                    </div>
                    per page
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #addPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
                class="fa popupClose">&#xf00d;</i></button>
        <div mat-dialog-title>
            <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <div id="filed-container" class="form-continer">
            <div class="row">
                <div class="col-md-6">
                    <div><label id="checkRequiredFor-validation"
                            for="email">{{dynamicLabel['CHECK_REQD_FOR']}}</label><span
                            class="mandatory-symbol">*</span></div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="selectedCheckRequiredFor"
                        (closed)="checkRequiredForTxt=''" (click)="focusSearch('checkRequiredForSearch')"
                        (keydown.enter)="focusSearch('checkRequiredForSearch')">
                        <input type="search" id="checkRequiredForSearch" class="dropdownsearchstyle"
                            [(ngModel)]="checkRequiredForTxt" matInput placeholder="search">
                        <mat-option class="unselectStyle" (onSelectionChange)="onCheckRequiredForRemoved($event)"
                            [value]="null">Un-select</mat-option>
                        <mat-option
                            *ngFor="let item of checkRequiredForListDropdown| assessmentSearch :checkRequiredForTxt"
                            (onSelectionChange)="onCheckRequiredForSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-md-6">
                    <div><label id="ownerField-validation" for="email">{{dynamicLabel['OWNER_NAME']}}</label><span
                            class="mandatory-symbol">*</span></div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="selectedOwner" (closed)="ownerTxt=''"
                        (click)="focusSearch('ownerSearch')" (keydown.enter)="focusSearch('ownerSearch')">
                        <input type="search" id="ownerSearch" class="dropdownsearchstyle" [(ngModel)]="ownerTxt"
                            matInput placeholder="search">
                        <mat-option class="unselectStyle" (onSelectionChange)="onOwnerRemoved(null)"
                            [value]="null">Un-select</mat-option>
                        <mat-option *ngFor="let item of ownerListDropdown| assessmentSearch :ownerTxt"
                            (onSelectionChange)="onOwnerSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
            <div class="row" style="margin-top: 6%;">
                <div class="col-md-6">
                    <div><label id="dueDate-validation" for="email">{{dynamicLabel['DUE_DATE']}}</label><span
                            class="mandatory-symbol">*</span></div>
                    <input id="dueDate" class="form-control data-picker-continer" type="text" bsDatepicker
                        [bsConfig]="dueDatePickerConfiguration" [dateCustomClasses]="datepickerDateCustomClasses"
                        [(ngModel)]="ecData.dueDate" (ngModelChange)="dueDateOnChanged($event)">
                </div>
                <div class="col-md-6">
                    <div><label for="email">{{dynamicLabel['REMIND_N_DAYS_BEFORE_DUE_DATE']}}</label></div>
                    <input class="input-filed-continers" type="number" (keydown)="validateNumberFields($event)"
                        [(ngModel)]="ecData.remindNDaysBeforeDueDate">
                </div>
            </div>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button mat-stroked-button class="addButton" (click)="addFunction(ecData)" *ngIf="visibleAddButton">
                <i class="fas fa-plus"></i> Add
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #deletePopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
        <div>
            <div class="row">
                <div class="col-md-12">
                    <div><label id="deleteReason-validation" for="email">Reason for Delete</label><span
                            class="mandatory-symbol">*</span></div>
                    <textarea id="deleteTextarea" type="text" class="input-filed-textarea uppercase"
                        style="width: 100%;" rows="4" cols="50" [(ngModel)]="ecData.deleteReason"
                        (focusout)="onFieldFocusout()"></textarea>
                </div>
            </div>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button mat-stroked-button class="deleteButton" (click)="deleteFunction(ecData)">
                <i class="fa fa-trash"></i> Delete
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #ecDetailsPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelDetailPopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="row frozen-popup-content" style="zoom: 95%;">
        <div class="col-md-4">
            <div class="row" style="line-height: 23px;" *ngIf="this.qualityService.moduleName=='CR'">
                <div class="col-sm-5"><label for="email"><b>Change Request ID :</b> </label></div>
                <div class="col-sm-7" style="padding-left: 20px;">
                    <span class="tooltip-style" matTooltip="{{this?.qualityService?.activity?.crId}}">
                        {{this?.qualityService?.activity?.crId}}
                    </span>
                </div>
            </div>
            <div class="row" style="line-height: 23px;" *ngIf="this.qualityService.moduleName=='CAPA'">
                <div class="col-sm-5"><label for="email"><b>CAPA ID :</b> </label></div>
                <div class="col-sm-7" style="padding-left: 20px;">
                    <span class="tooltip-style" matTooltip="{{this.qualityService.activity.capaId}}">
                        {{this.qualityService.activity.capaId}}
                    </span>
                </div>
            </div>
            <div class="row" style="line-height: 23px;" *ngIf="this.qualityService.moduleName=='DV'">
                <div class="col-sm-5"><label for="email"><b>Deviation ID :</b> </label></div>
                <div class="col-sm-7" style="padding-left: 20px;">
                    <span class="tooltip-style" matTooltip="{{this.qualityService.activity.dvId}}">
                        {{this.qualityService.activity.dvId}}
                    </span>
                </div>
            </div>
            <div class="row" style="line-height: 23px;" *ngIf="this.qualityService.moduleName=='IN'">
                <div class="col-sm-5"><label for="email"><b>Incident ID :</b> </label></div>
                <div class="col-sm-7">
                    <span class="tooltip-style" matTooltip="{{this.qualityService.activity.inId}}">
                        {{this.qualityService.activity.inId}}
                    </span>
                </div>
            </div>
            <div class="row" style="line-height: 23px;" *ngIf="this.qualityService.moduleName=='QI'">
                <div class="col-sm-5"><label for="email"><b>Quality Issue ID :</b> </label></div>
                <div class="col-sm-7">
                    <span class="tooltip-style" matTooltip="{{this.qualityService.activity.qiId}}">
                        {{this.qualityService.activity.qiId}}
                    </span>
                </div>
            </div>
            <div class="row" style="line-height: 23px;">
                <div class="col-sm-5"><label for="email"><b>Overall Status :</b> </label></div>
                <div class="col-sm-7" style="padding-left: 20px;">{{this.qualityService.activity.status }}
                </div>
            </div>
            <div class="row" style="line-height: 23px;"
                *ngIf="this.qualityService.moduleName=='CR' || this.qualityService.moduleName=='CAPA' || this.qualityService.moduleName=='DV' ">
                <div class="col-sm-5"><label for="email"><b>Owner :</b> </label></div>
                <div class="col-sm-7" style="padding-left: 20px;">
                    {{this.qualityService.activity.ownerUserName}}</div>
            </div>
            <div class="row" style="line-height: 23px;" *ngIf="this.qualityService.moduleName=='IN'">
                <div class="col-sm-5"><label for="email"><b>Evaluator :</b> </label></div>
                <div class="col-sm-7">{{this.qualityService.activity.evaluatorUser}}</div>
            </div>
            <div class="row" style="line-height: 23px;" *ngIf="this.qualityService.moduleName=='QI'">
                <div class="col-sm-5"><label for="email"><b>Evaluator :</b> </label></div>
                <div class="col-sm-7">{{this.qualityService.activity.evaluatorUser}}</div>
            </div>
            <div class="row" style="line-height: 23px;">
                <div class="col-sm-5" style="width: 44%;"><label for="email"><b>Expected Closure Date :</b> </label>
                </div>
                <div class="col-sm-6 text-uppercase">{{this.qualityService.activity.expcetedClosureOn|
                    date : (appService.getOneQmsDateFormat)}}
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="row" *ngIf="this.qualityService.moduleName=='CR'">
                <div><label for="email"><b>
                            {{qualityService.activityDynamicLabel?.['CURRENT_STATE']?.fieldName ??
                            'Current State'}}
                            :</b> </label></div>
                <div class="row d-flex align-items-center">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="qualityService.activity.currentState" [config]="config"
                            style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Current State', 'eye')"
                        (keydown.enter)="openEditor('Current State', 'eye')">
                        <i class="fa fa-eye eye"></i>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="this.qualityService.moduleName=='CAPA'">
                <div><label for="email"><b>
                            {{qualityService.activityDynamicLabel?.['CAPA_DESCRIPTION']?.fieldName ??
                            'CAPA Description'}}
                            :</b> </label></div>
                <div class="row d-flex align-items-center">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="qualityService.activity.capaDescription" [config]="config"
                            style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit" (click)="openEditor('CAPA Description', 'eye')"
                        (keydown.enter)="openEditor('CAPA Description', 'eye')">
                        <i class="fa fa-eye eye"></i>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="this.qualityService.moduleName=='DV'">
                <div><label for="email"><b> {{qualityService.activityDynamicLabel?.['DEVIATION_DESCRIPTION']?.fieldName
                            ??
                            'Deviation Description '}} :</b> </label></div>
                <div class="row d-flex align-items-center">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="qualityService.activity.dvDescription" [config]="config"
                            style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Deviation Description', 'eye')"
                        (keydown.enter)="openEditor('Deviation Description', 'eye')">
                        <i class="fa fa-eye eye"></i>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="this.qualityService.moduleName=='IN'">
                <div><label for="email"><b>{{qualityService.activityDynamicLabel?.['IMPACT_DESCRIPTION']?.fieldName ??
                            'Impact Description '}} :</b> </label></div>
                <div class="row d-flex align-items-center">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="qualityService.activity.impactDescription" [config]="config"
                            style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Impact Description', 'eye')"
                        (keydown.enter)="openEditor('Impact Description', 'eye')">
                        <i class="fa fa-eye eye"></i>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="this.qualityService.moduleName=='QI'">
                <div><label for="email"><b>{{qualityService.activityDynamicLabel?.['IMPACT_DESCRIPTION']?.fieldName ??
                            'Impact Description '}} :</b> </label></div>
                <div class="row d-flex align-items-center">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="qualityService.activity.impactDescription" [config]="config"
                            style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Impact Description', 'eye')"
                        (keydown.enter)="openEditor('Impact Description', 'eye')">
                        <i class="fa fa-eye eye"></i>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="this.qualityService.moduleName=='AU'">
                <div>
                    <label for="email">
                        <b> {{qualityService.activityDynamicLabel?.['AUDIT_PURPOSE']?.fieldName ??
                            'Audit Purpose'}} :
                        </b>
                    </label>
                </div>
                <div class="row d-flex align-items-center">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="qualityService.activity.auditPurpose" [config]="config"
                            style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Audit Purpose', 'eye')"
                        (keydown.enter)="openEditor('Audit Purpose', 'eye')">
                        <i class="fa fa-eye eye"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="row" *ngIf="this.qualityService.moduleName=='CR'">
                <div><label for="email"><b>{{qualityService.activityDynamicLabel?.['PROPOSED_CHANGE']?.fieldName ??
                            'Proposed Change'}}:</b> </label></div>
                <div class="row d-flex align-items-center">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="qualityService.activity.proposedChange" [config]="config"
                            style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Proposed Change', 'eye')"
                        (keydown.enter)="openEditor('Proposed Change', 'eye')">
                        <i class="fa fa-eye eye"></i>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="this.qualityService.moduleName=='CAPA'">
                <div><label for="email"><b>{{qualityService.activityDynamicLabel?.['INVESTIGATION_SUMMARY']?.fieldName
                            ??
                            'Investigation Summary'}}:</b> </label></div>
                <div class="row d-flex align-items-center">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="qualityService.activity.investigationSummary" [config]="config"
                            style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Investigation Summary', 'eye')"
                        (keydown.enter)="openEditor('Investigation Summary', 'eye')">
                        <i class="fa fa-eye eye"></i>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="this.qualityService.moduleName=='IN'">
                <div><label for="email"><b>
                            {{qualityService.activityDynamicLabel?.['DESCRIPTION']?.fieldName ??
                            'Description '}}:</b> </label></div>
                <div class="row d-flex align-items-center">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="qualityService.activity.description" [config]="config"
                            style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Description', 'eye')"
                        (keydown.enter)="openEditor('Description', 'eye')">
                        <i class="fa fa-eye eye"></i>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="this.qualityService.moduleName=='QI'">
                <div><label for="email"><b>
                            {{qualityService.activityDynamicLabel?.['DESCRIPTION']?.fieldName ??
                            'Description '}}:</b> </label></div>
                <div class="row d-flex align-items-center">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="qualityService.activity.description" [config]="config"
                            style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Description', 'eye')"
                        (keydown.enter)="openEditor('Description', 'eye')">
                        <i class="fa fa-eye eye"></i>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="this.qualityService.moduleName=='AU'">
                <div>
                    <label for="email">
                        <b>
                            {{qualityService.activityDynamicLabel?.['AUDIT_SCOPE']?.fieldName ??
                            'Audit Scope'}}:
                        </b>
                    </label>
                </div>
                <div class="row d-flex align-items-center">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="qualityService.activity.auditScope" [config]="config"
                            style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Audit Scope', 'eye')"
                        (keydown.enter)="openEditor('Audit Scope', 'eye')">
                        <i class="fa fa-eye eye"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr style="color: #cfcfcf;">
    <div style="max-height: 400px; overflow-y: scroll; overflow-x: hidden; margin: 15px;">
        <div class="row">
            <div class="col-md-3">
                <div><label for="email">{{dynamicLabel['EC_ID']}}</label></div>
                <input class="input-filed-continers" style="cursor: not-allowed;" type="text" [(ngModel)]="ecData.ecId"
                    [disabled]="true">
            </div>
            <div class="col-md-3">
                <div><label id="checkRequiredFor-validation" for="email">{{dynamicLabel['CHECK_REQD_FOR']}}</label><span
                        class="mandatory-symbol">*</span></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedCheckRequiredFor"
                    (closed)="checkRequiredForTxt=''" (click)="focusSearch('check-required-details')"
                    (keydown.enter)="focusSearch('check-required-details')"
                    [ngClass]="{'odd-item-mat-select':ischeckRequiredForOdd ==selectedCheckRequiredFor}"
                    [disabled]="isFrozen">
                    <input type="search" id="check-required-details" class="dropdownsearchstyle"
                        [(ngModel)]="checkRequiredForTxt" matInput placeholder="search">
                    <mat-option class="unselectStyle" (onSelectionChange)="onCheckRequiredForRemoved($event)"
                        [value]="null">Un-select</mat-option>
                    <mat-option *ngFor="let item of checkRequiredForListDropdown| assessmentSearch :checkRequiredForTxt"
                        (onSelectionChange)="onCheckRequiredForSelect($event,item)" [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-3">
                <div><label id="ownerField-validation" for="email">{{dynamicLabel['OWNER_NAME']}}</label><span
                        class="mandatory-symbol">*</span>
                    <label *ngIf="message.showSwitchUser" for="email" (click)="openSwitchUser('EC Owner')"
                        (keydown.enter)="openSwitchUser('EC Owner')"><a><img title="Switch User"
                                src="..//..//../assets/img/user-switch.png" alt="Yes" width="25"
                                height="25"></a></label>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedOwner" (closed)="ownerTxt=''"
                    (click)="focusSearch('ownerSearch1')" (keydown.enter)="focusSearch('ownerSearch1')"
                    [ngClass]="{'odd-item-mat-select':isownerOdd ==selectedOwner}"
                    [ngStyle]="isFrozen?{'cursor':'not-allowed'} : {'':''}" [disabled]="isFrozen">
                    <input type="search" id="ownerSearch1" class="dropdownsearchstyle" [(ngModel)]="ownerTxt" matInput
                        placeholder="search">
                    <mat-option class="unselectStyle" (onSelectionChange)="onOwnerRemoved(null)"
                        [value]="null">Un-select</mat-option>
                    <mat-option *ngFor="let item of ownerListDropdown| assessmentSearch :ownerTxt"
                        (onSelectionChange)="onOwnerSelect($event,item)" [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-3">
                <div><label for="email ">{{dynamicLabel['START_DATE']}}</label></div>
                <input id="startDate" class="form-control data-picker-continer" type="text" bsDatepicker
                    [bsConfig]="startDatePickerConfiguration" [dateCustomClasses]="datepickerDateCustomClasses"
                    [(ngModel)]="ecData.startDate" [ngStyle]="disableAllFields?{'cursor':'not-allowed'} : {'':''}"
                    [disabled]="isFrozen">
            </div>
            <div class="col-md-3">
                <div><label id="dueDate-validation" for="email">{{dynamicLabel['DUE_DATE']}}</label><span
                        class="mandatory-symbol">*</span>
                </div>
                <input class="form-control data-picker-continer" type="text" bsDatepicker
                    [bsConfig]="dueDatePickerConfiguration" [dateCustomClasses]="datepickerDateCustomClasses"
                    [(ngModel)]="ecData.dueDate" (ngModelChange)="dueDateOnChanged($event)" [disabled]="isFrozen"
                    [ngStyle]="disableAllFields?{'cursor':'not-allowed'} : {'':''}">
            </div>
            <div class="col-md-3">
                <div><label for="email">{{dynamicLabel['REMIND_N_DAYS_BEFORE_DUE_DATE']}}</label></div>
                <input class="input-filed-continers" type="text" id="templateName"
                    [(ngModel)]="ecData.remindNDaysBeforeDueDate" [disabled]="isFrozen"
                    [ngStyle]="disableAllFields?{'cursor':'not-allowed'} : {'':''}">
            </div>
            <div class="col-md-3" *ngIf="selectedCheckRequiredForValueExp == 'Over All'">
                <div><label id="methodology-validation" for="email">Methodology</label><span
                        class="mandatory-symbol">*</span></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedMethodology" (closed)="methodologyTxt=''"
                    (click)="focusSearch('methodologySearch')" (keydown.enter)="focusSearch('methodologySearch')"
                    [ngClass]="{'odd-item-mat-select':ismethodologyOdd ==selectedMethodology}" [disabled]="isFrozen"
                    [ngStyle]="disableAllFields?{'cursor':'not-allowed'} : {'':''}">
                    <input type="search" id="methodologySearch" class="dropdownsearchstyle" [(ngModel)]="methodologyTxt"
                        matInput placeholder="search">
                    <mat-option class="unselectStyle" (onSelectionChange)="onMethodologyRemoved(null)"
                        [value]="null">Un-select</mat-option>
                    <mat-option *ngFor="let item of methodologyListDropdown| assessmentSearch :methodologyTxt"
                        (onSelectionChange)="onMethodologySelect($event,item)" [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-3">
                <div><label for="email">{{dynamicLabel['STATUS']}}</label></div>
                <input class="input-filed-continers" type="text" id="status" style="cursor: not-allowed;"
                    [(ngModel)]="ecData.status" disabled>
            </div>
            <div class="col-md-3" *ngIf="ecData.approvedBy">
                <div>
                    <label for="email">{{dynamicLabel['APPROVER']}}</label>
                    <label *ngIf="message.showSwitchUser" id="owner-validation" for="email"
                        (click)="openSwitchUser('EC Approver')" (keydown.enter)="openSwitchUser('EC Approver')">
                        <a>
                            <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Yes" width="25"
                                height="25">
                        </a>
                    </label>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedApprovedBy" (closed)="approvedByTxt=''"
                    (click)="focusSearch('approvedBySearch')" (keydown.enter)="focusSearch('approvedBySearch')"
                    [ngClass]="{'odd-item-mat-select':isapprovedByOdd ==selectedApprovedBy}" [disabled]="isFrozen">
                    <input type="search" id="approvedBySearch" class="dropdownsearchstyle" [(ngModel)]="approvedByTxt"
                        matInput placeholder="search">
                    <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                    <mat-option *ngFor="let item of approvedByListDropdown| assessmentSearch :approvedByTxt"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-3" *ngIf="ecData.approvedOn!=null">
                <div><label for="email">{{dynamicLabel['APPROVED_ON']}}</label><span class="mandatory-symbol">*</span>
                </div>
                <input class="form-control data-picker-continer" type="text" bsDatepicker
                    [bsConfig]="dateTimePickerConfiguration" [disabled]="true"
                    [dateCustomClasses]="datepickerDateCustomClasses" [(ngModel)]="ecData.approvedOn"
                    [disabled]="isFrozen">
            </div>
            <div class=" col-md-6" *ngIf="ecData.approvalComments!=null">
                <div><label id="approvalComments-validation"
                        for="email">{{dynamicLabel['APPROVAL_COMMENTS']}}</label><span class="mandatory-symbol">*</span>
                </div>
                <div class="row">
                    <div class="row d-flex align-items-center">
                        <div class="hideToolbar col-sm-11">
                            <st-editor [(ngModel)]="ecData.approvalComments" [config]="config"
                                style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                        </div>
                        <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Approval Comments', 'eye')"
                            (keydown.enter)="openEditor('Approval Comments', 'eye')">
                            <i class="fa fa-eye eye"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class=" col-md-6" *ngIf="selectedCheckRequiredForValueExp == 'Over All'">
                <div><label id="criteria-validation" for="email">Criteria</label><span class="mandatory-symbol">*</span>
                </div>
                <div class="row">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="ecData.criteria" class="input-filed-continers hideToolbar"
                            [config]="config" (focusout)="onFieldFocusout()" [disabled]="isFrozen"
                            (paste)="onPaste($event)"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit"
                        (click)="!isFrozen ? openEditor('Criteria', 'edit') : openEditor('Criteria', 'eye')"
                        (keydown.enter)="!isFrozen ? openEditor('Criteria', 'edit') : openEditor('Criteria', 'eye')">
                        <i *ngIf="!isFrozen" class="far fa-edit"></i>
                        <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
                    </div>
                </div>
            </div>
            <div class="col-md-6" *ngIf="showConclusion || ecData.conclusion!=null">
                <div><label id="conclusion-validation"
                        for="email">{{qualityService.activityDynamicLabel?.['EFFECTIVENESS_CHECK_AND_CONCLUSION']?.fieldName
                        ?? 'Effectiveness Check and Conclusion'}}:</label><span class="mandatory-symbol">*</span></div>
                <div class="row">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="ecData.conclusion" class="input-filed-continers hideToolbar"
                            [config]="config" (focusout)="onFieldFocusout()" [disabled]="isFrozen && !eliteConclusion"
                            (paste)="onPaste($event)"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit"
                        (click)="isFrozen && !eliteConclusion ? openEditor('Effectiveness Check and Conclusion', 'eye') : openEditor('Effectiveness Check and Conclusion', 'edit')"
                        (keydown.enter)="isFrozen && !eliteConclusion ? openEditor('Effectiveness Check and Conclusion', 'eye') : openEditor('Effectiveness Check and Conclusion', 'edit')">
                        <i *ngIf="!(isFrozen && !eliteConclusion)" class="far fa-edit"></i>
                        <i *ngIf="isFrozen && !eliteConclusion" class="fa fa-eye eye"></i>

                    </div>
                </div>
            </div>
            <div class="col-md-3" *ngIf="ecData.qaApprovedBy">
                <div>
                    <label for="email">{{dynamicLabel['QA_APPROVER']}}</label>
                    <label *ngIf="message.showSwitchUser" for="email" (click)="openSwitchUser('EC QA Approver')"
                        (keydown.enter)="openSwitchUser('EC QA Approver')">
                        <a>
                            <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Yes" width="25"
                                height="25">
                        </a>
                    </label>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedQAApprovedBy"
                    (closed)="QaapprovedByTxt=''" (click)="focusSearch('focus-qa-approver')"
                    (keydown.enter)="focusSearch('focus-qa-approver')"
                    [ngClass]="{'odd-item-mat-select':  isQaapprovedByOdd ==selectedQAApprovedBy}"
                    [disabled]="isFrozen">
                    <input type="search" id="focus-qa-approver" class="dropdownsearchstyle"
                        [(ngModel)]="QaapprovedByTxt" matInput placeholder="search">
                    <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                    <mat-option *ngFor="let item of QAapprovedByListDropdown| assessmentSearch :QaapprovedByTxt"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-3" *ngIf="ecData.qaApprovedOn!=null">
                <div><label for="email">{{dynamicLabel['QA_APPROVED_ON']}}</label><span
                        class="mandatory-symbol">*</span></div>
                <input class="form-control data-picker-continer" type="text" bsDatepicker [disabled]="true"
                    [bsConfig]="dateTimePickerConfiguration" [dateCustomClasses]="datepickerDateCustomClasses"
                    [(ngModel)]="ecData.qaApprovedOn">
            </div>
            <div class=" col-md-6" *ngIf="ecData.qaApprovalComments!=null">
                <div><label for="email">{{dynamicLabel['QA_APPROVAL_COMMENTS']}}</label><span
                        class="mandatory-symbol">*</span></div>
                <div class="row d-flex align-items-center">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="ecData.qaApprovalComments" [config]="config"
                            style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit" (click)="openEditor('QA Approval Comments', 'eye')"
                        (keydown.enter)="openEditor('QA Approval Comments', 'eye')">
                        <i class="fa fa-eye eye"></i>
                    </div>
                </div>
            </div>
            <div class=" col-md-6" *ngIf="ecData.closureComments">
                <div><label for="email">{{dynamicLabel['CLOSURE_COMMENTS']}}</label><span
                        class="mandatory-symbol">*</span></div>
                <div class="row d-flex align-items-center">
                    <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="ecData.closureComments" [config]="config"
                            style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
                    </div>
                    <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Closure Comments', 'eye')"
                        (keydown.enter)="openEditor('Closure Comments', 'eye')">
                        <i class="fa fa-eye eye"></i>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button style="margin-left: 1%;" mat-stroked-button class="addButton" *ngFor="let button of buttonList"
                (click)="dynamicButtonClick(ecData,button)">
                <i class="fas fa-user-edit"></i> {{button}}
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelDetailPopup()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>

        <div class="tab">
            <mat-tab-group mat-stretch-tabs class="ectab mat-tab-container mat-elevation-z4" animationDuration="0ms"
                (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex">
                <mat-tab [label]="getTabLabel()" *ngIf="selectedCheckRequiredForValueExp != 'Over All'">
                    <div class="form-template ActivityPage" style="margin-top:2%;">
                        <ng-container
                            *ngIf="selectedCheckRequiredForValueExp === 'Individual Action Items' || selectedCheckRequiredForValueExp === 'Individual Preliminary Actions'">
                            <app-tasks-ec-actions [effectivenessCheckData]="ecData"
                                *ngIf="refreshTaskEcTabComponents"></app-tasks-ec-actions>
                        </ng-container>
                        <ng-container *ngIf="selectedCheckRequiredForValueExp == 'Individual Findings'">
                            <app-tasks-ec-findings [ec]="ecData"
                                *ngIf="refreshTaskEcTabComponents"></app-tasks-ec-findings>
                        </ng-container>
                    </div>
                </mat-tab>
                <mat-tab label="Participants">
                    <div class="form-template ActivityPage" style="margin-top:2%;">
                        <app-tasks-ec-participants [effectivenessCheckData]="ecData"
                            *ngIf="refreshTaskEcTabComponents"></app-tasks-ec-participants>
                    </div>
                </mat-tab>
                <mat-tab label="Documents">
                    <div class="form-template ActivityPage" style="margin-top:2%;">
                        <app-tasks-ec-documents [effectivenessCheckData]="ecData"
                            *ngIf="refreshTaskEcTabComponents"></app-tasks-ec-documents>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</ng-template>
<ng-template #confirmWithReasonPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelFunc()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ buttonLabel }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
        <div class="form-continer">
            <div class="row">
                <div class="col-sm-12" *ngIf="buttonLabel=='QA Approve'||buttonLabel==='Approve'">
                    <div><label id="buttonLabel-validation" for="email">{{buttonLabel}}</label><span
                            class="mandatory-symbol">*</span></div>
                    <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedStatus">
                        <mat-radio-button class="tp-radio-button" *ngFor="let status of reviewStatus" [value]="status"
                            (change)="radioChange($event)">
                            {{status}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="col-md-12" *ngIf="isEsignRequired">
                    <div class=""><label for="username ">User Name</label><span class="mandatory-symbol">*</span></div>
                    <div class=""> <input id="username" style="height: 80% !important;" class="input-filed-continers"
                            type="text" [(ngModel)]="userName" disabled>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="(isEsignRequired && !isAdenabled)">
                    <div class=""><label id="password-validation" for="pass ">Password</label><span
                            class="mandatory-symbol">*</span></div>
                    <div class="">
                        <input id="EsignRequiredPassword" autocomplete="off" onpaste="return false;"
                            ondrop="return false;" style="height: 80% !important;" class="input-filed-continers"
                            [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password"
                            noCopyPaste (focusout)="onButtonOperationFieldFocusout()">
                        <span class="eyeicon-container eye-color" (click)="showPassword()"
                            (keydown.enter)="showPassword()">
                            <i
                                [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
                        </span>
                    </div>
                </div>
                <div class="col-md-12"
                    *ngIf="buttonLabel=='Submit for Approval'|| buttonLabel=='Re-Submit for Approval'">
                    <div><label id="approveBy-validation" for="email">Approve By</label><span
                            class="mandatory-symbol">*</span></div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="selectedApprovedBy"
                        (closed)="approvedByTxt1=''" (click)="focusSearch('approvedBySearch1')"
                        (keydown.enter)="focusSearch('approvedBySearch1')">
                        <input type="search" id="approvedBySearch1" class="dropdownsearchstyle"
                            [(ngModel)]="approvedByTxt1" matInput placeholder="search">
                        <mat-option class="unselectStyle" (onSelectionChange)="onApprovedByRemoved(null)"
                            [value]="null">Un-select</mat-option>
                        <mat-option *ngFor="let item of approvedByListDropdown| assessmentSearch :approvedByTxt1"
                            (onSelectionChange)="onApprovedBySelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-md-12" *ngIf="buttonLabel=='Send to QA'|| buttonLabel=='Re-Send to QA'">
                    <div><label id="qaApproveBy-validation" for="email">QA Approve By</label><span
                            class="mandatory-symbol">*</span></div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="selectedQAApprovedBy"
                        (closed)="QAApprovedBy1=''" (click)="focusSearch('QaapprovedBySearch1')"
                        (keydown.enter)="focusSearch('QaapprovedBySearch1')">
                        <input type="search" id="QaapprovedBySearch1" class="dropdownsearchstyle"
                            [(ngModel)]="QAApprovedBy1" matInput placeholder="search">
                        <mat-option class="unselectStyle" (onSelectionChange)="onQaApprovedByRemoved(null)"
                            [value]="null">Un-select</mat-option>
                        <mat-option *ngFor="let item of QAapprovedByListDropdown| assessmentSearch :QAApprovedBy1"
                            (onSelectionChange)="onQaApprovedBySelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-md-12" *ngIf="this.buttonLabel=='Approve'||this.buttonLabel=='QA Approve'">
                    <div><label id="comments-validation" for="reason"> Comments</label><span
                            class="mandatory-symbol">*</span></div>
                    <textarea id="reason" rows="4" class="textarea-filed-continers" type="text" [(ngModel)]="reason"
                        (focusout)="onButtonOperationFieldFocusout()"></textarea>
                </div>
                <div class="col-md-12" *ngIf="showClosedStatusFields">
                    <div><label id="outcome-validation" for="email">{{dynamicLabel['OUTCOME']}}</label><span
                            class="mandatory-symbol">*</span></div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="selectedOutcome" (closed)="outcomeTxt=''"
                        (click)="focusSearch('outcomeSearch1')" (keydown.enter)="focusSearch('outcomeSearch1')">
                        <input type="search" id="outcomeSearch1" class="dropdownsearchstyle" [(ngModel)]="outcomeTxt"
                            matInput placeholder="search">
                        <mat-option class="unselectStyle" (onSelectionChange)="onOutcomeRemoved(null)"
                            [value]="null">Un-select</mat-option>
                        <mat-option *ngFor="let item of outcomeListDropdown| assessmentSearch :outcomeTxt"
                            (onSelectionChange)="onOutcomeSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-md-12" *ngIf="showClosedStatusFields">
                    <div><label id="closureComments-validation" for="reason">
                            {{dynamicLabel['CLOSURE_COMMENTS']}}</label><span class="mandatory-symbol">*</span></div>
                    <textarea id="reason" rows="4" cols="50" class="textarea-filed-continers textare-style" type="text"
                        [(ngModel)]="ecData.closureComments" (focusout)="onButtonOperationFieldFocusout()"></textarea>
                </div>
            </div>
            <br>
            <div class="row" *ngIf="this.outcomeValue=='Set New Check Date'" style="margin-left: -7%;">
                <div class="form-continer">
                    <div class="row">
                        <div class="col-md-6">
                            <div><label id="checkRequire-validation"
                                    for="email">{{dynamicLabel['CHECK_REQD_FOR']}}</label><span
                                    class="mandatory-symbol">*</span></div>
                            <mat-select matInput placeholder="Select" [(ngModel)]="selectedNewCheckRequiredFor"
                                (closed)="newCheckRequiredForTxt=''" (keydown.enter)="focusSearch('new-check-required')"
                                (click)="focusSearch('new-check-required')">
                                <input type="search" id="new-check-required" class="dropdownsearchstyle"
                                    [(ngModel)]="newCheckRequiredForTxt" matInput placeholder="search">
                                <mat-option class="unselectStyle"
                                    (onSelectionChange)="onNewCheckRequiredForRemoved(null)"
                                    [value]="null">Un-select</mat-option>
                                <mat-option
                                    *ngFor="let item of checkRequiredForListDropdown| assessmentSearch :newCheckRequiredForTxt"
                                    (onSelectionChange)="onNewCheckRequiredForSelect($event,item)"
                                    [value]="item.valueExp">
                                    {{ item.displayExp }}
                                </mat-option>
                            </mat-select>
                        </div>
                        <div class="col-md-6">
                            <div><label id="owner-validation" for="email">{{dynamicLabel['OWNER_NAME']}}</label><span
                                    class="mandatory-symbol">*</span></div>
                            <mat-select matInput placeholder="Select" [(ngModel)]="selectedNewOwner"
                                (closed)="ownerTxt=''" (click)="focusSearch('focus-new-owner')"
                                (keydown.enter)="focusSearch('focus-new-owner')">
                                <input type="search" id="focus-new-owner" class="dropdownsearchstyle"
                                    [(ngModel)]="ownerTxt" matInput placeholder="search">
                                <mat-option class="unselectStyle" (onSelectionChange)="onOwnerRemoved(null)"
                                    [value]="null">Un-select</mat-option>
                                <mat-option *ngFor="let item of ownerListDropdown| assessmentSearch :ownerTxt"
                                    (onSelectionChange)="onOwnerSelect($event,item)" [value]="item.valueExp">
                                    {{ item.displayExp }}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 6%;">
                        <div class="col-md-6">
                            <div><label id="due-validation" for="email">{{dynamicLabel['DUE_DATE']}}</label><span
                                    class="mandatory-symbol">*</span></div>
                            <input class="form-control data-picker-continer" type="text" bsDatepicker
                                [bsConfig]="dueDatePickerConfiguration"
                                [dateCustomClasses]="datepickerDateCustomClasses" [(ngModel)]="newEcData.dueDate"
                                (ngModelChange)="dueDateOnChanged($event)">
                        </div>
                        <div class="col-md-6">
                            <div><label for="email">{{dynamicLabel['REMIND_N_DAYS_BEFORE_DUE_DATE']}}</label></div>
                            <input class="input-filed-continers" type="number" (keydown)="validateNumberFields($event)"
                                [(ngModel)]="newEcData.remindNDaysBeforeDueDate">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button *ngIf="buttonLabel != ''" mat-stroked-button class="addButton" (click)="confirmWithReasonFunc()">
                {{buttonLabel}}
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #editor>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelEditor()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ editorTitle }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div><br>
    <div class="row">
        <div class="col-md-12 st-editor">
            <st-editor [(ngModel)]="editorValue" [config]=" allowEditing ? includeButtons : excludeButtons"
                [spellcheck]="true" (paste)="onPaste($event)"></st-editor>
        </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" *ngIf="allowEditing" (click)="saveEditor(editorValue)">
            <i class="fas fa-check"></i> Save
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()"></app-switchuser>
<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-editor #clobViewPopup></app-editor>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmit()"></app-grid-reorder>